export const SEPARATOR = "_";

export const CALL_API = "callApi";

export const requestStatus = {
	BEGIN: "BEGIN",
	SUCCESS: "SUCCESS",
	FAILURE: "FAILURE"
};

export const states = {
	BEGIN: {
		isLoading: true,
		isSuccess: false
	},
	SUCCESS: {
		isLoading: false,
		isSuccess: true
	},
	FAILURE: {
		isLoading: false,
		isSuccess: false
	}
};

const API_ACTION_PREFIX = `FETCH${SEPARATOR}`;
const API_BEGIN_SUFFIX = SEPARATOR + requestStatus.BEGIN;
const API_SUCCESS_SUFFIX = SEPARATOR + requestStatus.SUCCESS;
const API_FAILURE_SUFFIX = SEPARATOR + requestStatus.FAILURE;

export const actionStrings = {
	API_ACTION_PREFIX,
	API_BEGIN_SUFFIX,
	API_SUCCESS_SUFFIX,
	API_FAILURE_SUFFIX
};
